import Config from '@Config';
import Devices from '@Config/devices';
import BaseScene from "@Scenes/BaseScene";
import * as Scenes from '@Config/scenes';
import Delay from '@Utils/Time/Delay';
import EventEmitter from '@Utils/Events/EventEmitter';

class CountDownScene extends BaseScene
{

    constructor()
    {
        super(Scenes.COUNT_DOWN);
    }

    public create()
    {
        this.startCountDown();

        if (Config.DEVICE === Devices.DESKTOP)
        {
            this.createControlsText();
        }
    }

    private createControlsText()
    {
        const gameSize = this.getGameSize();

        const fontStyle = { fontFamily: 'Permanent Marker', fontSize: '25px', color: '#000000', stroke: '#FFFFFF', strokeThickness: 5 };

        const helpText = this.add.text(gameSize.centerX, 400, 'Use arrow keys', fontStyle);
        helpText.setOrigin(0.5);

        this.tweens.add({targets:helpText, alpha: 0, delay: 1000, duration: 1000 });
    }

    /**
     * Start Count Down
     */
    async startCountDown()
    {
        const fontStyle = { fontFamily: 'Permanent Marker', fontSize: '50px', color: '#000000', stroke: '#FFFFFF', strokeThickness: 5 };

        const gameSize = this.getGameSize();

        const countDown = this.add.text(gameSize.centerX, 200, '3', fontStyle);
        countDown.setOrigin(0.5);
        countDown.setAlign('center');
        const tweenConfig = {
            targets: countDown,
            scaleX: 3,
            scaleY: 3,
            alpha: 0,
            duration: 400
        };

        const tween = this.tweens.add(tweenConfig);

        await Delay(1000);

        countDown.setText('2');

        tween.restart();

        await Delay(1000);

        countDown.setText('1');

        tween.restart();

        await Delay(1000);

        countDown.setText('Go!');

        tween.restart();

        EventEmitter.emit(Scenes.COUNT_DOWN, 'complete');
    }
}

export default CountDownScene;